import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'beautyapp-sider',
    templateUrl: './sider.component.html',
    styleUrls: ['./sider.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SiderComponent {
  @Input() isCollapsed = false;
}
